"use strict"

class Actu {
    constructor() {
        this.isMobile = false;
        this.isDesktop = false;
        this.mobileToDesktop = false;
        this.desktopToMobile = false;
        this.breakpoint = 1200;
        this.noResize = false;
        this.actu = document.querySelector('.sl-Actu')
        if (this.actu) {
            this.leftArrow = this.actu.querySelector('.actu-left-arrow');
            this.rightArrow = this.actu.querySelector('.actu-right-arrow');
        }
    }
    renderMethodOnLoad() {
        window.innerWidth < this.breakpoint ? this.mobileMethod() : this.desktopMethod()
        window.innerWidth < this.breakpoint ? this.isDesktop = true : this.isMobile = true;
    }
    renderMethodOnResize() {
        window.onresize = () => {
            if (window.innerWidth < this.breakpoint) {
                this.isDesktop = true;
                if (this.isMobile) this.mobileMethod()
                this.isMobile = false;
                this.desktopToMobile = true
            } else {
                this.isMobile = true;
                if (this.isDesktop) this.desktopMethod()
                this.isDesktop = false;
                this.mobileToDesktop = true;
            }
        };
    }
    mobileMethod() {
        // generate carousel only on mobile
        $('.sl-Actu .tiles .actu-slick > ul').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            prevArrow: this.leftArrow,
            nextArrow: this.rightArrow,
            responsive: [
                {
                    breakpoint: this.breakpoint,
                    settings: {
                        centerMode: true,
                        variableWidth: true,
                        variableHeight: true
                    }
                }
            ]
        })
    }
    desktopMethod() {
        // destroy generated carousel
        if (this.mobileToDesktop) $('.sl-Actu .tiles .actu-slick > ul').slick('unslick');
    }
    setSlick() {
        if (this.actu) {
            // call method on load
            this.renderMethodOnLoad()
            // call resize method
            if (this.noResize) this.renderMethodOnResize()
        }
    }
}

export default Actu;


// WEBPACK FOOTER //
// ./src/scripts/components/Actu.js